export default __webpack_public_path__ + "d2d1337bb85afd0f40a26bf022eeb06f.svg";